window.addEventListener("message", (e) => {
  if (e.data.type === "hsFormCallback" && e.data.eventName === "onFormSubmit") {
    let dataArr = e.data.data;

    dataArr.forEach(function (obj) {
      if (obj.name == "email") {
        let hsUserEmail = obj.value;
        clarity("identify", hsUserEmail);
      }
    });
  }
});
